import * as S from './styles';

export interface ISearchBar {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
}

const SearchBar = ({ handleChange, value }: ISearchBar) => (
  <S.SearchBar placeholder='Search...' onChange={handleChange} value={value} />
);

export default SearchBar;
